<template>
  <div class="page">
    <div class="category-main">
      <div class="category-item">
        <div class="category-key">分类类目管理:</div>
        <div class="category-val">
          <b-goods-category isEdit isInit />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.page {
  padding-bottom: 10px;
  .category-main {
    .category-item {
      display: flex;
      .category-key {
        width: 108px;
        margin-right: 5px;
        line-height: 28px;
        text-align: right;
      }
      .category-val {
        flex: 1;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
